import type { AgentProfileResponse } from "@/react/hooks/agent_profile/useAgentProfileInfo";
import { Body } from "./Body";
import { Loader } from "./Loader";
import { Sidebar } from "./Sidebar";
import { AgentProfileContextProvider } from "./context";

interface AgentProfileProps {
  agent?: AgentProfileResponse;
  isFullPageView?: boolean;
  isLoading: boolean;
  onClose?: () => void;
}

export const AgentProfile = ({
  agent,
  isLoading,
  isFullPageView = false,
  onClose,
}: AgentProfileProps) => (
  <AgentProfileContextProvider
    isFullPageView={isFullPageView}
    agent={agent}
    isLoading={isLoading}
    onClose={onClose}
  >
    {agent ? (
      <>
        <Sidebar />
        <Body />
      </>
    ) : (
      <Loader />
    )}
  </AgentProfileContextProvider>
);
